import type { CashierTransaction, CashierTransactionStatus } from '../services/cashierApi';

export function getTxStatus(tx: CashierTransaction): CashierTransactionStatus {
  const raw = tx.transactionStatus ?? tx.status ?? 'completed';
  if (raw === 'pending_approval' || raw === 'rejected' || raw === 'cancelled') return raw;
  return 'completed';
}

export function formatTxType(type?: string): string {
  switch (type) {
    case 'redeem_credits':
      return 'Redemption';
    case 'deposit_credits':
      return 'Deposit';
    case 'process_withdrawal':
      return 'Withdrawal';
    default:
      return type?.replace(/_/g, ' ') || 'Transaction';
  }
}

export function txStatusLabel(status: CashierTransactionStatus): string {
  switch (status) {
    case 'pending_approval':
      return 'Pending approval';
    case 'rejected':
      return 'Rejected';
    case 'cancelled':
      return 'Cancelled';
    default:
      return 'Completed';
  }
}

export function txStatusBadgeClass(status: CashierTransactionStatus): string {
  switch (status) {
    case 'pending_approval':
      return 'bg-amber-50 text-amber-800';
    case 'rejected':
      return 'bg-rose-50 text-rose-700';
    case 'cancelled':
      return 'bg-stone-100 text-stone-500';
    default:
      return 'bg-emerald-50 text-emerald-700';
  }
}

export function txAmountClass(type: string | undefined, status: CashierTransactionStatus): string {
  if (type === 'redeem_credits') {
    if (status === 'pending_approval') return 'text-amber-700';
    if (status === 'rejected' || status === 'cancelled') return 'text-stone-400 line-through';
    return 'text-stone-800';
  }
  if (type === 'deposit_credits') return 'text-emerald-700';
  return 'text-stone-800';
}
